import { render, staticRenderFns } from "./DIASEstateAttachment.vue?vue&type=template&id=1b0269d3&"
import script from "./DIASEstateAttachment.vue?vue&type=script&lang=js&"
export * from "./DIASEstateAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports